import gql from "graphql-tag";

export default gql`
	mutation cancelSubscriptionByIDV2(
		$subscriptionId: Int!
		$cancellationSurvey: CancellationSurveyInput!
	) {
		cancelSubscriptionByIDV2(
			subscriptionID: $subscriptionId
			cancellationSurvey: $cancellationSurvey
		) {
			... on CancelSubscriptionByIDSuccess {
				result
			}

			... on CancelSubscriptionByIDFailure {
				errorCode
				message
			}
		}
	}
`;

export const readCancelSubscriptionByIDV2Result = ({ data }) =>
	data && {
		...data.cancelSubscriptionByIDV2,
	};
